export default {
  API_URL: process.env.REACT_APP_API_URL,
  IMAGE_PATH: process.env.REACT_APP_IMAGE_PATH,
  CLIENT_URL: process.env.REACT_APP_CLIENT_URL,
};

// export const PORT = process.env.PORT || 3001
